import * as React from 'react';
import classNames from 'classnames';
import warningPng from '../../images/warning.png';
import './FormView.less';
import { hasValue } from '../../lib/utils';
import PrimaryButton from './buttons/PrimaryButton';
import SecondaryButton from './buttons/SecondaryButton';
import Buttons from './Buttons';

const FormView = (props: Props) => {
	if (!props.children) return null;
	const { buttonIcon, isSubmitButtonVisible, errorMessage } = props;
	const longTextThreshold = 100;
	const longError = typeof errorMessage === 'string' && errorMessage.length > longTextThreshold;

	const onSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (hasValue(props.onFormSubmit)) {
			props.onFormSubmit();
		}
	};

	return (
		<form className={classNames('k-form', 'formLayout', props.className)} onSubmit={onSubmit}>
			{props.children}
			{errorMessage !== null && (
				<div className={classNames('error', longError ? 'longText' : '')}>
					<div className="imgWrapper">
						<img src={warningPng} width="16" height="13" alt="Error messager" />
					</div>
					<div className="errorBody">{longError ? <span>{errorMessage}</span> : errorMessage}</div>
				</div>
			)}
			{isSubmitButtonVisible && (
				<Buttons centre={props.centreButtons} left={props.buttonsLeftAligned}>
					{props.onCancelButtonClick && (
						<SecondaryButton text={props.cancelButtonText ?? 'Cancel'} onClick={props.onCancelButtonClick} />
					)}
					<PrimaryButton
						text={props.submitButtonText}
						img={buttonIcon}
						type="submit"
						tabIndex={props.submitButtonTabIndex}
						disabled={props.disabled}
					/>
				</Buttons>
			)}
		</form>
	);
};

interface Props {
	className?: string;
	errorMessage?: string | React.ReactNode;
	onFormSubmit?: (event?: React.SyntheticEvent) => void;
	onCancelButtonClick?: (event: React.MouseEvent) => void;
	submitButtonText?: string;
	cancelButtonText?: string;
	submitButtonTabIndex?: number;
	isSubmitButtonVisible?: boolean;
	buttonIcon?: JSX.Element;
	children?: React.ReactNode;
	disabled?: boolean;
	centreButtons?: boolean;
	buttonsLeftAligned?: boolean;
}

FormView.defaultProps = {
	className: null,
	errorMessage: null,
	onFormSubmit: null,
	onCancelButtonClick: null,
	submitButtonText: null,
	cancelButtonText: null,
	submitButtonTabIndex: null,
	isSubmitButtonVisible: true,
	buttonIcon: null,
	children: null,
	disabled: null,
	centreButtons: true,
	buttonsLeftAligned: false
};

export default FormView;
